// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		// suggestionStyle: 'style2',
		// suggestionStyle2MainContainerSelector: 'body',
		// suggestionMobileStyle: 'style2',
		//suggestionMode: 'test',
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function (suggestionElement, searchElement, searchBoxId) {
	};

	SearchInput.prototype.afterBindEvents = function() {
		if(jQ('.boost-pfs-search-box').length > 0) {
      // Wrap input in form & bind events
			jQ('.boost-pfs-search-box').wrap('<form class="boost-pfs-search-box-form" action="/search" method="get" role="search"></form>');
      jQ('.boost-pfs-search-box-form').on('submit', this._onSubmit.bind(this));
			jQ('.boost-pfs-search-btn-close-suggestion').on('click', function() {
				jQ('.modal--close').trigger('click');
			})
		}
	}

})();